import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import { formatDateWithTime } from 'utils/other';

const DraggablePreview = ({ onDrag, handleOpen, getPreview, TitlePath, DatePath, DescriptionPath, changeSelectionType, selectionType }) => {
    const [previewData, handleData] = useState(null);
    const [loading, handleLoad] = useState(false);
    const [error, handleError] = useState(null);

    useEffect(() => {
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [TitlePath, DatePath, DescriptionPath]);

    const getData = async () => {
        try {
            handleLoad(true);
            handleError(null);
            const preview = await getPreview();
            handleData(preview.news);
            handleLoad(false);
        } catch (e) {
            handleLoad(false);    
            console.log('get preview Error: ', e)        
            if (e.errors && e.errors.hasOwnProperty('title_path')) {
                handleError('The Title must be selected');
            }
        }
    };

    return (
        <Draggable
            onStart={() => onDrag(true)}
            onStop={() => onDrag(false)}
            handle=".drag-item"
            bounds={{
                bottom: window.innerHeight - 640,
                top: -120,
                right: 0,
                left: -window.innerWidth + 340,
            }}
            onDrag={onDrag}
        >
            <div className="preview-container">
                <div className="drag-container">
                    <h3 className="drag-item">Newsfeed Preview:</h3>
                    <i onClick={() => handleOpen(false)} className="fas fa-times" />
                </div>
                <div className="preview-box">
                    <div>
                        {loading || (!previewData && !error) ? (
                            <i className="fa fa-spinner fa-spin" />
                        ) : !error ? (
                            previewData.length === 0 ? (
                                <div className="preview-feed_item">
                                    News was not found
                                </div>
                            ) : 
                            previewData.map((item, index) => {
                                return (
                                    <div key={index} className="preview-feed_item">
                                        <a style={{ color: '#20a8d8' }} className="d-block" href={item.url} target="noopener noreferrer _blank">
                                            {item.title}
                                        </a>
                                        {item.abstract ? <span>{item.abstract}</span> : ''}
                                        <br />
                                        {DatePath && item.publishedAt ? <em style={{ color: 'rgb(134, 159, 172)' }}>{formatDateWithTime(item.publishedAt)}</em> : ''}
                                    </div>
                                );
                            })
                        ) : (
                            <div className="error-container">
                                <i className="fas not-found-icon fa-exclamation-triangle" />
                                <div className="not-found-link">The Title must be selected</div>
                            </div>
                        )}
                    </div>
                    {selectionType === '1' ?
                        <div className="toggle_selection_type-container">
                            Incorrect field selected? <br/>
                            <span className="toggle_selection_type-trigger" onClick={changeSelectionType}>
                                Try alternative option
                            </span>
                        </div>
                        :
                        <div className="toggle_selection_type-container">
                            <span className="toggle_selection_type-trigger" onClick={changeSelectionType}>
                                Return to default selection option
                            </span>
                        </div>
                    }
                </div>
            </div>
        </Draggable>
    );
};

export default DraggablePreview;
